var arrayLocations = [
    {
       "location_tag": "CO-11",
       "location_id": 63350734999,

     },
     {
       "location_tag": "CO-12",
       "location_id": 63350866071,

      },
      {
       "location_tag": "CO-14",
       "location_id": 63350931607,

      },
      {
       "location_tag": "CO-15",
       "location_id": 63351062679,
      },
      {
       "location_tag": "CO-18",
       "location_id": 63351128215,
      },
      {
       "location_tag": "CO-19",
       "location_id": 63351292055, 
      },
      {
       "location_tag": "CO-20",
       "location_id": 63351357591,
      },
      {
       "location_tag": "CO-23",
       "location_id": 63351554199,  
      },
      {
      "location_tag": "CO-24",
      "location_id": 63351750807,
      }
      ]